export const collectionsHeaderHeight = 56;
